export const formatPhoneNumber = num => {
    if (num === undefined || num === null) {
        return;
    }

    let isStringOnlyNumbers = /^\d+$/;
    if (!isStringOnlyNumbers.test(num)) {
        return num;
    }

    let newNum = num.split('');
    if (newNum[0] === '4' || newNum[0] === '9') {
        return mobilePhone(newNum);
    } else {
        return landPhone(newNum);
    }
};

const mobilePhone = num => {
    num.splice(3, 0, ' ');
    num.splice(6, 0, ' ');
    return num.join('');
};

const landPhone = num => {
    num.splice(2, 0, ' ');
    num.splice(5, 0, ' ');
    num.splice(8, 0, ' ');
    return num.join('');
};
